(function ($) {

	if(typeof careerCTAPhotos != "undefined"){
		var randomImg = careerCTAPhotos[Math.floor(Math.random() * careerCTAPhotos.length)];
		$('.career-cta-image').html(randomImg);
	}

})(jQuery);
